(function () {
  const popup = document.getElementById('czCartAbandonPopup');
  if (!popup) return;

  const STORAGE_KEYS = {
    dismissed: 'cz_winter10_cart_dismissed_until',
    shownSession: 'cz_winter10_cart_shown_session',
    accepted: 'cz_winter10_offer_accepted',
    addToCart: 'cz_exit_popup_added_to_cart',
    checkoutStarted: 'cz_exit_popup_checkout_started'
  };

  const isCartPage = window.location.pathname === '/cart';
  const config = {
    enabled: popup.dataset.enabled === 'true',
    delaySeconds: isCartPage ? 60 : parseInt(popup.dataset.delaySeconds || '45', 10),
    hideForDays: parseInt(popup.dataset.hideForDays || '7', 10),
    offerCode: popup.dataset.offerCode || 'Winter10',
    title: popup.dataset.title || 'لسه في حاجة في الكارت 🛒',
    text: popup.dataset.text || 'كمّلي طلبك دلوقتي وخدي 10% خصم.',
    buttonText: popup.dataset.buttonText || 'فعّلي 10% وكمّلي الدفع',
    closeText: popup.dataset.closeText || 'هكمّل بعدين',
    hintText: popup.dataset.hintText || 'الخصم بيتفعّل تلقائيًا لما تضغطي على الزر.'
  };

  if (!config.enabled) return;

  const titleEl = popup.querySelector('#czCartPopupTitle');
  const textEl = popup.querySelector('.cz-cart-popup__text');
  const codeEl = popup.querySelector('#czCartPopupCode');
  const hintEl = popup.querySelector('.cz-cart-popup__hint');
  const mainCtaBtn = popup.querySelector('#czCartPopupMainCta');
  const secondaryBtn = popup.querySelector('.cz-cart-popup__secondary');

  if (titleEl) titleEl.textContent = config.title;
  if (textEl) textEl.textContent = config.text;
  if (codeEl) codeEl.textContent = config.offerCode;
  if (hintEl) hintEl.textContent = config.hintText;
  if (mainCtaBtn) mainCtaBtn.textContent = config.buttonText;
  if (secondaryBtn) secondaryBtn.textContent = config.closeText;

  const now = Date.now();
  const dismissedUntil = parseInt(localStorage.getItem(STORAGE_KEYS.dismissed) || '0', 10);
  const shownSession = sessionStorage.getItem(STORAGE_KEYS.shownSession) === 'true';
  const accepted = localStorage.getItem(STORAGE_KEYS.accepted) === 'true';
  if (dismissedUntil > now || shownSession || accepted) return;

  let popupShown = false;
  let popupOpening = false;
  let inactivityTimer = null;
  let eligibilityArmed = false;
  let hiddenAt = null;
  const startedAt = Date.now();
  const AUTO_DISCOUNT_THRESHOLD = 300000;

  function pushEvent(name, extra) {
    const payload = Object.assign({
      offer_code: config.offerCode,
      offer_version: 'winter10_v2',
      recovery_stage: 'post_atc'
    }, extra || {});

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, payload));

    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('cazameeza:' + name, payload);
      }
    } catch (e) {
      console.warn('Shopify analytics.publish failed', e);
    }
  }

  function checkoutStarted() {
    return sessionStorage.getItem(STORAGE_KEYS.checkoutStarted) === 'true';
  }

  function markCheckoutStarted() {
    sessionStorage.setItem(STORAGE_KEYS.checkoutStarted, 'true');
    clearTimeout(inactivityTimer);
    eligibilityArmed = false;
  }

  async function getCart() {
    try {
      const response = await fetch('/cart.js', {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) return null;
      return await response.json();
    } catch (e) {
      return null;
    }
  }

  function cartHasDiscount(cart) {
    if (!cart) return false;
    const cartLevel = Array.isArray(cart.cart_level_discount_applications)
      ? cart.cart_level_discount_applications.length
      : 0;
    return Number(cart.total_discount || 0) > 0 || cartLevel > 0;
  }

  function isEligibleCart(cart) {
    if (!cart) return false;
    if (checkoutStarted()) return false;
    if (localStorage.getItem(STORAGE_KEYS.accepted) === 'true') return false;
    if (Number(cart.item_count || 0) <= 0) return false;
    if (cartHasDiscount(cart)) return false;
    if (Number(cart.original_total_price || 0) >= AUTO_DISCOUNT_THRESHOLD) return false;
    return true;
  }

  function startInactivityTimer() {
    if (!eligibilityArmed || popupShown || checkoutStarted()) return;
    clearTimeout(inactivityTimer);
    inactivityTimer = setTimeout(function () {
      openPopup('inactivity');
    }, config.delaySeconds * 1000);
  }

  async function refreshEligibilityAndArm() {
    const cart = await getCart();
    eligibilityArmed = isEligibleCart(cart);

    if (eligibilityArmed) {
      sessionStorage.setItem(STORAGE_KEYS.addToCart, 'true');
      startInactivityTimer();
    } else {
      clearTimeout(inactivityTimer);
    }
  }

  async function openPopup(triggerType) {
    if (popupShown || popupOpening || checkoutStarted()) return;
    popupOpening = true;

    const cart = await getCart();
    const eligible = isEligibleCart(cart);
    popupOpening = false;
    eligibilityArmed = eligible;
    if (!eligible || popupShown) return;

    popupShown = true;
    clearTimeout(inactivityTimer);
    popup.classList.add('is-visible');
    popup.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cz-popup-lock');
    document.body.classList.add('cz-popup-lock');
    sessionStorage.setItem(STORAGE_KEYS.shownSession, 'true');

    pushEvent('cz_cart_popup_shown', {
      trigger_type: triggerType,
      cart_value: Number(cart.original_total_price || 0) / 100,
      item_count: Number(cart.item_count || 0)
    });
  }

  function closePopup(reason) {
    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cz-popup-lock');
    document.body.classList.remove('cz-popup-lock');

    const hideUntil = Date.now() + (config.hideForDays * 24 * 60 * 60 * 1000);
    localStorage.setItem(STORAGE_KEYS.dismissed, String(hideUntil));
    pushEvent('cz_cart_popup_closed', { reason: reason || 'manual' });
  }

  if (mainCtaBtn) {
    mainCtaBtn.addEventListener('click', function () {
      localStorage.setItem(STORAGE_KEYS.accepted, 'true');
      sessionStorage.setItem(STORAGE_KEYS.checkoutStarted, 'true');
      pushEvent('cz_cart_popup_cta_clicked', { action: 'apply_discount_and_checkout' });
      window.location.assign(
        '/discount/' + encodeURIComponent(config.offerCode) + '?redirect=' + encodeURIComponent('/checkout')
      );
    });
  }

  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = (form.getAttribute('action') || '').toLowerCase();

    if (action.includes('/cart/add')) {
      sessionStorage.setItem(STORAGE_KEYS.addToCart, 'true');
      setTimeout(refreshEligibilityAndArm, 900);
    }

    if (action.includes('/checkout')) {
      markCheckoutStarted();
    }
  });

  document.addEventListener('click', function (e) {
    const target = e.target;
    if (!(target instanceof Element)) return;

    const addToCartButton = target.closest('[name="add"], .product-form__submit, .ajax-add-to-cart, .add-to-cart');
    if (addToCartButton) {
      sessionStorage.setItem(STORAGE_KEYS.addToCart, 'true');
      setTimeout(refreshEligibilityAndArm, 900);
    }

    const checkoutButton = target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"], .cart__checkout-button');
    if (checkoutButton) {
      markCheckoutStarted();
    }

    const closeTrigger = target.closest('[data-close-cart-popup]');
    if (closeTrigger) closePopup('dismiss');
  });

  ['mousemove', 'scroll', 'keydown', 'touchstart'].forEach(function (evt) {
    window.addEventListener(evt, function () {
      if (eligibilityArmed) startInactivityTimer();
    }, { passive: true });
  });

  document.addEventListener('mouseout', function (e) {
    if (window.innerWidth < 992 || !eligibilityArmed) return;
    if ((Date.now() - startedAt) < 12000) return;
    if (e.clientY <= 0) openPopup('exit_intent');
  });

  window.addEventListener('scroll', function () {
    if (window.innerWidth >= 992 || !eligibilityArmed || isCartPage || popupShown) return;
    if ((Date.now() - startedAt) < 20000) return;

    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    const percent = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;

    if (percent > 70) {
      clearTimeout(window.czWinter10CartMobileDelay);
      window.czWinter10CartMobileDelay = setTimeout(function () {
        openPopup('mobile_scroll_intent');
      }, 1200);
    }
  }, { passive: true });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      hiddenAt = Date.now();
      return;
    }

    if (hiddenAt && eligibilityArmed && (Date.now() - hiddenAt) >= 30000) {
      openPopup('tab_return');
    }
    hiddenAt = null;
  });

  refreshEligibilityAndArm();
})();
